export default __webpack_public_path__ + "static/media/block-icon.0ae454d4.svg";